import http from '../../http'

const API_URL = "proper_waste_disposal" 

class EliminacionResiduosAPI {

  async save(program) {
    const response = await http(`${API_URL}/save`, 'POST', program)
    return response
  }
  async saveEvidence(program) {
    const response = await http(`activity-health-evidence/save`, 'POST', program)
    return response
  }
  

  async getEvidence(id) {
    const response = await http(`activity-health-evidence/show/${id}`)
    return response || null
  } 



  async getTraining(companyID) {
    const response = await http(`${API_URL}/index/${companyID}`)
    return response || null
  } 

  
  async getShow(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response || null
  } 

  async getAll(companyID, page, search) {
    const response = await http(`${API_URL}/index/${companyID}?page=${page}&search=${search}`, 'POST')
    return response || null
  } 

  async get(companyID, page, search) {
    const response = await http(`${API_URL}/index/${companyID}?page=${page}&search=${search}`, 'POST')
    return response || null
  }
 
  async update(id, program) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', program)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }
   
}

export default new EliminacionResiduosAPI()